/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as moment from 'moment';
import 'moment-timezone';

export function getBudgetNetworkTimezone(adnTimeShifter: any, chartOptionsUtil?: any): string {
  return chartOptionsUtil?.getNetworkTimezone?.()
    || adnTimeShifter?.getNetworkTimezone?.()
    || 'utc';
}

export function networkDayFromApiDate(apiDate: Date | string | null | undefined, adnTimeShifter: any): string | null {
  if (!apiDate) {
    return null;
  }
  return adnTimeShifter.getMomentInNetworkTimezone(apiDate).format('YYYY-MM-DD');
}

export function networkDayFromPickerDate(pickerDate: Date, adnTimeShifter: any): string {
  return adnTimeShifter.getMomentInNetworkTimezone(pickerDate).format('YYYY-MM-DD');
}

export function normalizeBudgetDay(
  day: string | Date | null | undefined,
  adnTimeShifter: any,
  networkTimezone: string
): string | null {
  if (!day) {
    return null;
  }
  if (typeof day === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(day)) {
    return day;
  }
  return moment(day).tz(networkTimezone).format('YYYY-MM-DD');
}

export function pickerDateForNetworkDay(day: string, networkTimezone: string, boundary: 'start' | 'end'): Date {
  const dayMoment = moment.tz(day, networkTimezone);
  return (boundary === 'start' ? dayMoment.startOf('day') : dayMoment.endOf('day')).toDate();
}

export function utcApiDateFromNetworkPicker(pickerDate: Date, adnTimeShifter: any, boundary: 'start' | 'end'): Date {
  const dayMoment = adnTimeShifter.getMomentInNetworkTimezone(pickerDate);
  return (boundary === 'start' ? dayMoment.clone().startOf('day') : dayMoment.clone().endOf('day')).toDate();
}

export function isBudgetPeriodEditable(startDay: string, endDay: string, networkTimezone: string): boolean {
  const now = moment.tz(networkTimezone);
  return moment.tz(startDay, networkTimezone).startOf('day').isAfter(now)
    || moment.tz(endDay, networkTimezone).endOf('day').isAfter(now);
}

export function isCurrentBudgetPeriod(startDay: string, endDay: string, networkTimezone: string): boolean {
  const now = moment.tz(networkTimezone);
  return moment.tz(startDay, networkTimezone).startOf('day').isSameOrBefore(now)
    && moment.tz(endDay, networkTimezone).endOf('day').isSameOrAfter(now);
}

export function addSecondForUi(budgets: any[]): any[] {
  for (let i = 0; i < budgets.length; i++) {
    const prev = i > 0 ? budgets[i - 1] : null;
    const current = budgets[i];
    if (!prev) {
      continue;
    }
    if (moment(prev.modEndDay).diff(moment(current.modStartDay), 'seconds') === 0) {
      current.modStartDay = moment(current.modStartDay).add(1, 'second').toDate();
    }
  }
  return budgets;
}
